import { useState, useEffect, useCallback } from 'react';
import PubSub from 'pubsub-js';

import loadScript from 'core/utils/load-script';
import ramblerPushPropTypes from 'core/utils/prop-types/rambler-push';

import { STORIES_MODAL_STATE } from 'core/components/stories/constants';

import withoutSSR from 'core/components/withoutSSR';


const SDK_SRC = 'https://pushadmin.rambler.ru/sdk/sdk.js';
let timerId;
let storiesModalStateSubscription;
let ramblerPush;
let ramblerPushPromise;

export const getRamblerPush = async () => {
  if (!ramblerPush) {
    if (!ramblerPushPromise) {
      ramblerPushPromise = new Promise((resolve, reject) => {
        window.RamblerPush = window.RamblerPush || [];
        window.RamblerPush.push(() => {
          ramblerPush = window.RamblerPush;
          resolve();
        });
        loadScript(SDK_SRC).catch(error => reject(error));
      });
    }

    await ramblerPushPromise;
  }

  return ramblerPush;
};

function RamblerPush(props, context) {
  const { ramblerPush: { projectUuid, vapidKey } } = context;
  const [ramblerPushApi, setRamblerPushApi] = useState();
  const [isSupported, setIsSupported] = useState(null);
  const [ramblerPushError, setRamblerPushError] = useState(null);

  const lazyForStories = useCallback(() => {
    storiesModalStateSubscription = PubSub.subscribe(STORIES_MODAL_STATE, (eventName, { opened }) => {
      if (opened) {
        clearTimeout(timerId);
        return;
      }

      getRamblerPush().then(setRamblerPushApi);
    });
  }, []);

  useEffect(() => {
    if (!ramblerPushApi) {
      timerId = setTimeout(() => {
        getRamblerPush().then(setRamblerPushApi);
      }, 30000);
    }

    lazyForStories();

    return () => {
      clearTimeout(timerId);
      storiesModalStateSubscription && PubSub.unsubscribe(storiesModalStateSubscription);
    };
  }, [lazyForStories, ramblerPushApi]);

  useEffect(() => {
    if (!ramblerPushApi) return;

    ramblerPushApi
      .getAvailability()
      .then(({ isRamblerPushAvailable }) => setIsSupported(isRamblerPushAvailable));
  }, [ramblerPushApi]);

  const subscribe = useCallback(async () => {
    try {
      const { error: initializeError } = await ramblerPushApi.initialize({ projectUuid, vapidKey });

      if (initializeError) setRamblerPushError(initializeError);
    } catch (error) {
      setRamblerPushError(error);
    }
  }, [ramblerPushApi, projectUuid, vapidKey]);

  useEffect(() => {
    if (!isSupported) console.warn('RamblerPush not supported');
    if (!ramblerPushApi || !isSupported) return;

    subscribe();
  }, [ramblerPushApi, isSupported, subscribe]);

  useEffect(() => {
    if (ramblerPushError) {
      console.warn('Ошибка инициализации RamblerPush', ramblerPushError.message);
    }
  }, [ramblerPushError]);

  return null;
}

RamblerPush.contextTypes = {
  ramblerPush: ramblerPushPropTypes,
};

export default withoutSSR(RamblerPush);
